import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findGoods = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/price_config?` + params,
        method: 'GET'
    })
}
export const findProject = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/project/select?` + params,
        method: 'GET'
    })
}
export const addOrUpdateGoods = (params) => {
    if (params.id) {
        return request({
            url: `${baseUrl}/joins-sales-cloud/v1/price_config`,
            method: 'PUT',
            data: params
        })
    }else{
        return request({
            url: `${baseUrl}/joins-sales-cloud/v1/price_config`,
            method: 'POST',
            data: params
        })
    }
}
export const getGoodsForm = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/price_config/${id}`,
        method: 'GET'
    })
}
export const delGoods = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/price_config/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}